<template>
  <div v-if="visible" class="error-toast" :class="{ light: isLightTheme }">
    <span class="error-message">{{ message }}</span>
  </div>
</template>

<script setup>

import { defineProps, watch, ref, onMounted } from "vue";

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  duration: {
    type: Number,
    default: 4000,
  },
});

const visible = ref(true);
const isLightTheme = ref(false);

watch(() => props.message, () => {
  visible.value = true;
  setTimeout(() => (visible.value = false), props.duration);
});

onMounted(() => {
  const updateTheme = () => {
    isLightTheme.value = document.documentElement.getAttribute("data-theme") === "light";
  };

  updateTheme();
  const observer = new MutationObserver(updateTheme);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
});

</script>

<style scoped>

.error-toast {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: white;
  padding: 12px 20px;
  border-radius: 12px;
  font-family: "Eastman-Regular", sans-serif;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  z-index: 9999;
  animation: fadein 0.3s ease, fadeout 0.3s ease 3.7s;
}

.error-toast.light {
  background: #f4f4f4;
  color: #222;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

@keyframes fadein {
  from { opacity: 0; transform: translateX(-50%) translateY(20px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@keyframes fadeout {
  to { opacity: 0; transform: translateX(-50%) translateY(20px); }
}
</style>